import { createTable, Icon } from "@inmagik/magik-ui"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useState } from "react"
import { Link } from "react-router-dom"
import { MEDIA_TYPES } from "../../constants"
import { useDeleteMediaDocument, usePartialUpdateMediaDocument } from "../../hooks/documents"
import type { FiltersBase, RecordMedia } from "../../types"
import MediaDocumentModal from "./MediaDocumentModal"

const Table = createTable<RecordMedia>()

export function TableMedia({
  recordMedia: medias,
  recordId,
  setFilters,
  filters,
  refetch,
}: {
  recordMedia: RecordMedia[]
  recordId: number
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  refetch: () => void
}) {
  // const [sort, setSort] = useState<string>("")
  const [selectedRows, setSelectedRows] = useState<number[]>([])
  const [modalImmagineUpdateState, modalImmagineUpdateActions] = useModalTrigger()
  const updateMediaDocument = usePartialUpdateMediaDocument()
  const deleteMediaDocument = useDeleteMediaDocument()

  return (
    <>
      <Table
        data={medias}
        className="w-100 overflow-scroll flex-1"
        orderBy={filters.ordering.replace("-", "")}
        orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
        onOrderChange={(field, direction) => {
          if (field) {
            if (direction === "desc") {
              setFilters({ ...filters, ordering: `-${field}` })
            } else {
              setFilters({ ...filters, ordering: field })
            }
          } else {
            setFilters({ ...filters, ordering: "" })
          }
        }}
      >
        <Table.HeaderConfig sticky />

        <Table.BodyConfig />

        <Table.Selection
          selectionField="id"
          selectedRows={selectedRows}
          onSelectionChange={(rows) => {
            setSelectedRows(rows)
          }}
        />

        <Table.Column
          title="Media"
          name="media_file"
          sortable
          width="minmax(max-content, 1fr)"
          render={(media) => (
            <Link to={`/media/media/${media.media_data?.id}`}>
              {media.media_data?.thumbnail ? (
                <img
                  src={media.media_data.thumbnail as string}
                  alt={media.media_data.title}
                  style={{ maxWidth: 100, maxHeight: 100 }}
                />
              ) : (
                "N/A"
              )}
            </Link>
          )}
          stickyLeft
        />

        <Table.Column
          title="Tipo media"
          name="media_type"
          sortable
          width="minmax(max-content, 1fr)"
          render={(media) => (
            <span>{MEDIA_TYPES.find((type) => type.value === media.media_data?.media_type)?.label || "N/A"}</span>
          )}
        />

        <Table.Column
          title="Ordine"
          name="order"
          sortable
          width="minmax(max-content, 1fr)"
          render={(media) => <span>{media.order}</span>}
        />

        <Table.Column
          title="Copertina"
          name="cover"
          sortable
          width="minmax(max-content, 1fr)"
          render={(media) => <span>{media.cover ? "Sì" : "No"}</span>}
        />

        <Table.Column
          title="Titolo"
          name="title"
          sortable
          width="minmax(200px, 1fr)"
          render={(media) => <span dangerouslySetInnerHTML={{ __html: media.media_data?.source || "N/A" }} />}
        />

        <Table.Column
          title="Azione"
          name="actions"
          width="minmax(100px, 1fr)"
          render={(media) => (
            <>
              <Icon
                icon="edit"
                size={20}
                className="text-primary pointer ms-3"
                onClick={() => {
                  modalImmagineUpdateActions.open(media)
                }}
              />
              <Icon
                icon="delete"
                size={20}
                className="text-danger pointer ms-3"
                onClick={async () => {
                  await deleteMediaDocument(recordId, media.id)
                  refetch()
                }}
              />
            </>
          )}
          stickyRight
        />
      </Table>
      {modalImmagineUpdateState.isOpen && (
        <MediaDocumentModal
          title="Aggiorna Immagine"
          mediaDocument={modalImmagineUpdateState.value}
          id={modalImmagineUpdateState.value}
          show={modalImmagineUpdateState.isOpen}
          onClose={modalImmagineUpdateActions.close}
          save={async (values) => {
            if (typeof values.media_data?.media_file === "string") {
              delete values.media_data.media_file
            }
            await updateMediaDocument(recordId, Number(modalImmagineUpdateState.value.id), values).then(() => {
              modalImmagineUpdateActions.close()
              refetch()
            })
          }}
        />
      )}
    </>
  )
}
